<template>
  <LoadingOverlay :loading="loading" />
  <div v-if="!loading" class="home">
    <Header
      navbar-type="goBack"
      :screen-title="getPeriodsStatementsDates(periodDates.endDate)"
      @clicked="goBack"
    />
    <div class="container mt-0" id="statement-detail">
      <div class="head-title w-100">
        <img
          :src="useAsset('img/logo_bg_white.svg')"
          width="150"
          height="50"
          alt="Payjoy Logo"
          class="m-0 p-0"
        />
        <h1 class="small d-block text-center mb-0">
          {{ t("STATEMENT_DETAILS_TITLE") }}
        </h1>
      </div>
      <br /><br /><br />
      <div class="info">
        <ul>
          <li>{{ statementDetails.fullName }}</li>
          <li>{{ statementDetails.address }}</li>
          <li>{{ statementDetails.deviceTag }}</li>
        </ul>
      </div>
      <div class="info">
        <ul>
          <li>
            {{ `${t("STATEMENT_DETAILS_PERIODS.period")}` }}
            <span class="fw-bold">{{
              getPeriodsStatementsDates(periodDates.startDate)
            }}</span
            >{{ `${t("STATEMENT_DETAILS_PERIODS.to")}`
            }}<span class="fw-bold">{{
              getPeriodsStatementsDates(periodDates.endDate)
            }}</span>
          </li>
          <li>
            {{
              t("STATEMENT_DETAILS_STATEMENT_DATE", {
                date: getPeriodsStatementsDates(periodDates.endDate),
              })
            }}
          </li>
        </ul>
      </div>
      <div class="date-payment d-grid w-100 mt-4">
        <span class="fw-bold">{{ t("STATEMENT_DETAILS_PAYMENT_DATE") }}</span>
        <span class="text-end">{{
          getPeriodsStatementsDates(periodDates.endDate)
        }}</span>
        <span class="fw-bold">{{ t("STATEMENT_DETAILS_PAYMENT_AMOUNT") }}</span>
        <span class="text-end">{{
          currencyFormat(statementDetails.paymentAmount)
        }}</span>
      </div>
      <!--///////////////////ACCOUNT SUMMARY///////////////////-->
      <div class="account-summary mt-4 px-2">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="fw-bold ps-0 info-title">
                {{ t("STATEMENT_DETAILS_ACCOUNT_SUMMARY") }}
              </th>
              <th scope="col" class="text-end"></th>
            </tr>
          </thead>
          <tbody class="table-group-divider">
            <tr>
              <th scope="row" class="fw-normal text-start">
                {{ t("STATEMENT_DETAILS_PREVIOUS_BALANCE") }}
              </th>
              <td class="text-end">
                {{ currencyFormat(statementDetails.previousStatementBalance) }}
              </td>
            </tr>
            <tr>
              <th scope="row">{{ t("STATEMENT_DETAILS_WITHDRAWALS") }}</th>
              <td class="text-end">
                {{ currencyFormat(statementDetails.totalWithdrawalsAmount) }}
              </td>
            </tr>
            <tr>
              <th scope="row">{{ t("STATEMENT_DETAILS_PAYMENTS") }}</th>
              <td colspan="2" class="text-end">
                -{{ currencyFormat(statementDetails.totalPaymentsAmount) }}
              </td>
            </tr>
            <tr>
              <th scope="row">
                {{ t("STATEMENT_DETAILS_INTERESTS_CHARGED") }}
              </th>
              <td colspan="2" class="text-end">
                {{ currencyFormat(statementDetails.interestsCharged) }}
              </td>
            </tr>
            <tr>
              <th scope="row">{{ t("STATEMENT_DETAILS_TAXES") }}</th>
              <td colspan="2" class="text-end">
                {{ currencyFormat(statementDetails.taxPaid) }}
              </td>
            </tr>
            <tr v-show="showStatementField(StatementFields.AVAILABILITY_FEE)">
              <th scope="row">
                {{ t("STATEMENT_DETAILS_AVAILABILITY_FEES") }}
              </th>
              <td colspan="2" class="text-end">
                {{ currencyFormat(statementDetails.availabilityFeesPaid) }}
              </td>
            </tr>
            <tr v-show="showStatementField(StatementFields.AVAILABILITY_FEE)">
              <th scope="row">
                {{ t("STATEMENT_DETAILS_AVAILABILITY_FEES_TAX") }}
              </th>
              <td colspan="2" class="text-end">
                {{ currencyFormat(statementDetails.availabilityFeesTaxPaid) }}
              </td>
            </tr>
            <tr v-show="showStatementField(StatementFields.INSURANCE_FEE)">
              <th scope="row">{{ t("STATEMENT_DETAILS_INSURANCE_FEES") }}</th>
              <td colspan="2" class="text-end">
                {{
                  currencyFormat(
                    statementDetails.insuranceFeesPaidIncludingCommission
                  )
                }}
              </td>
            </tr>

            <tr>
              <th scope="row" class="fw-bold">
                {{ t("STATEMENT_DETAILS_CLOSING_BALANCE") }}
              </th>
              <td colspan="2" class="text-end fw-bold">
                {{ currencyFormat(statementDetails.closingBalance) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--///////////////////CREDIT INFO///////////////////////-->
      <div class="credit-info d-grid w-100 px-2 mt-5">
        <span class="fw-bold text-black">{{
          t("STATEMENT_DETAILS_CREDIT_LIMIT")
        }}</span>
        <span class="text-end">{{
          currencyFormat(statementDetails.creditLimit)
        }}</span>
        <span class="fw-bold text-black">{{
          t("STATEMENT_DETAILS_CREDIT_AVAILABLE")
        }}</span>
        <span class="text-end">{{
          currencyFormat(statementDetails.availableCredit)
        }}</span>
      </div>
      <div class="ops-detail mt-5 px-2">
        <h2 class="p-0 m-0 text-black" id="ops-detail-title">
          {{ t("STATEMENT_DETAILS_TRANSACTION_DETAILS") }}
        </h2>
        <table class="table mt-0 pt-0" title="Detalle">
          <thead class="p-0">
            <tr class="p-0">
              <th scope="col" class="p-0"></th>
              <th scope="col" class="p-0"></th>
              <th scope="col" class="p-0 text-end"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="p-0 table-group-divider">
              <th scope="col" class="fw-bold ps-0">
                {{ t("STATEMENT_DETAILS_DATE") }}
              </th>
              <th scope="col" class="fw-bold">
                {{ t("STATEMENT_DETAILS_DESCRIPTION") }}
              </th>
              <th scope="col" class="text-end fw-bold pe-0">
                {{ t("STATEMENT_DETAILS_AMOUNT") }}
              </th>
            </tr>
            <tr
              v-for="(transaction, index) in statementTransactions"
              :key="index"
            >
              <th scope="row" class="fw-normal text-start">
                {{ getShortDates(transaction.transactionDate) }}
              </th>
              <td class="">{{ getTransactionCopy(transaction) }}</td>
              <td class="text-end">
                {{
                  currencyFormat(
                    transaction.type === "PAYMENT" ||
                      transaction.type === "CREDIT"
                      ? -transaction.totalAmount
                      : transaction.totalAmount
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--///////////////////COSTS INFO////////////////////////-->
      <div class="costs-info mt-2 px-2">
        <table class="table costs-table">
          <thead>
            <tr>
              <th scope="col" class="fw-bold ps-0 info-title">
                {{ t("STATEMENT_DETAILS_CHARGE_SUMMARY") }}
              </th>
              <th scope="col" class="text-end"></th>
            </tr>
          </thead>
          <tbody class="table-group-divider">
            <tr>
              <th
                scope="row"
                class="fw-normal text-start w-100 commissions-label"
              >
                {{ t("STATEMENT_DETAILS_FEES") }}
              </th>
              <td class="commissions-value text-end">
                {{ t("STATEMENT_DETAILS_FEES_VAL") }}
              </td>
            </tr>
            <tr v-show="showStatementField(StatementFields.IVA)">
              <th scope="row">{{ t("STATEMENT_DETAILS_VAT") }}</th>
              <td class="text-end">{{ taxPercent }}</td>
            </tr>
            <tr v-show="showStatementField(StatementFields.CAT)">
              <th scope="row">{{ t("STATEMENT_DETAILS_CAT") }}</th>
              <td colspan="2" class="text-end">
                {{ catRate }}
              </td>
            </tr>
            <tr>
              <th scope="row">{{ t("STATEMENT_DETAILS_ANNUAL_RATE") }}</th>
              <td colspan="2" class="text-end">
                {{ statementDetails.annualPercentageRate }}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--///////////////////DISPUTES//////////////////////////-->
      <div class="mt-2 px-2">
        <table class="table table-borderless disputes-table">
          <thead>
            <tr>
              <th scope="col" class="fw-bold ps-0 border-bottom info-title">
                {{ t("DISPUTES_TITLE") }}
              </th>
              <th scope="col" class="text-end border-bottom"></th>
            </tr>
          </thead>
          <tbody class="table-group-divider">
            <tr>
              {{
                disputeMsg
              }}
            </tr>
          </tbody>
        </table>
      </div>
      <!--///////////////////CONTACT INFO//////////////////////-->
      <div class="contact-info mt-2 px-2">
        <table class="table table-borderless">
          <thead>
            <tr>
              <th scope="col" class="fw-bold ps-0 border-bottom info-title">
                {{ t("STATEMENT_DETAILS_CONTACT") }}
              </th>
              <th scope="col" class="text-end border-bottom"></th>
            </tr>
          </thead>
          <tbody class="table-group-divider">
            <tr>
              <th scope="row" class="fw-normal text-start" colspan="4">
                {{ accountStatementsSettings.values?.legalName }}
              </th>
            </tr>
            <tr>
              <th scope="row" colspan="4">
                {{ accountStatementsSettings.values?.address ?? "" }}
              </th>
            </tr>
            <tr>
              <th scope="row" class="contact-label fw-bold text-black">
                Whatsapp
              </th>
              <td class="contact-value text-end">
                {{ accountStatementsSettings.values?.phoneNumber ?? "" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--///////////////////FOOTER////////////////////////////-->
      <footer>
        <p class="fst-italic">
          {{ t("STATEMENT_DETAILS_FOOTER") }}
        </p>
        <p>{{ accountStatementsSettings.values?.userNotice }}</p>
      </footer>
    </div>
    <Alert
      v-if="showAlert"
      :message="t('DELINQUENT_ALERT')"
      alertType="alert-danger"
      closable
      alertIcon="fa fa-exclamation-triangle"
      @onClose="dismissAlert"
    />
    <div
      class="d-flex justify-content-center w-100"
      :class="hideDownloadBtn ? 'd-none' : ''"
    >
      <button
        class="btn pj-green-btn my-1 w-75"
        id="download-btn"
        @click="downloadStatement"
      >
        {{ t("DOWNLOAD") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import Header from "@/shared-components/consumer/Header.vue";
import { Service } from "@/apps/credit-line/services/network.service";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import {
  IAccountStatements,
  IAccountTransaction,
  IStatementsPeriod,
} from "@/apps/credit-line/models/IAccountStatement";
import currencyFormat from "@/apps/credit-line/helpers/currencyFormatter.helper";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import html2pdf from "html2pdf.js";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";
import {
  getPeriodsStatementsDates,
  getShortDates,
  getTransactionSource,
  getTransactionType,
} from "@/apps/credit-line/helpers/statements.helper";
import { getLanguageName } from "@/apps/credit-line/helpers/translations.helper";
import Alert from "@/shared-components/common/Alert.vue";
import {
  DEFAULT_SETTING,
  SettingValue,
} from "@/shared-models/consumer/ISetting";
import { SettingsCategory } from "@/shared-models/consumer/SettingsCategory";
import { useStore } from "vuex";
import { getSetting } from "@/apps/credit-line/helpers/consumerSettings.helper";
import { formatNumber } from "@/apps/credit-line/helpers/formatNumber.helper";
import LoadingOverlay from "@/shared-components/ui/core-app/LoadingOverlay.vue";
declare const Android: AndroidInterface;
enum StatementFields {
  IVA = "IVA",
  CAT = "CAT",
  AVAILABILITY_FEE = "availabilityFeeRate",
  INSURANCE_FEE = "insuranceFeeRate",
}

const route = useRoute();
const router = useRouter();
const { t, te, locale } = useI18n();
const CreditLineService = new Service();
const statementDetails = ref({} as IAccountStatements);
const periodDates = ref({} as IStatementsPeriod);
const statementTransactions = ref([] as IAccountTransaction[]);
const hideDownloadBtn = ref<boolean>(false);
const showAlert = ref<boolean>(false);
const loading = ref<boolean>(true);
const store = useStore();
const accountStatementsSettings = ref<SettingValue>(DEFAULT_SETTING);

const formatPercentageSetting = (
  value?: string | number | string[]
): string => {
  if (value === undefined || value === null) {
    return "";
  }

  if (Array.isArray(value)) {
    return value.join(", ");
  }

  const stringValue = value.toString().trim();
  if (!stringValue) {
    return "";
  }

  return stringValue.endsWith("%") ? stringValue : `${stringValue}%`;
};

function replacePhoneNumberPlaceholder(str, value) {
  if (typeof str !== "string") return str;
  return str.replace(/\{phoneNumber\b[^}]*\}/gi, value);
}

const taxPercent = computed(() =>
  formatPercentageSetting(accountStatementsSettings.value.values?.taxPercent)
);

const catRate = computed(
  () => formatNumber(Number(statementDetails.value?.cat)) + "%"
);

const disputeMsg = computed(() => {
  const phoneNumber = accountStatementsSettings.value.values?.phoneNumber || "";
  if (locale.value.includes("en")) {
    return replacePhoneNumberPlaceholder(
      accountStatementsSettings.value.values?.disputes?.en || "",
      phoneNumber
    );
  }

  if (locale.value.includes("es")) {
    return replacePhoneNumberPlaceholder(
      accountStatementsSettings.value.values?.disputes?.es || "",
      phoneNumber
    );
  }
  return "";
});

const fetchStatementDetails = async (): Promise<IAccountStatements> => {
  const response = await CreditLineService.getStatementDetails({
    deviceTag: AuthenticationHelper.getDeviceTag(),
    startDate: periodDates.value.startDate,
    endDate: periodDates.value.endDate,
    startTimestamp: periodDates.value.startTimestamp,
    endTimestamp: periodDates.value.endTimestamp,
  });

  return response.data;
};

const showStatementField = (id: string): boolean => {
  const fields = accountStatementsSettings.value.values?.fields;
  return Array.isArray(fields) && fields.includes(id);
};

onMounted(async () => {
  try {
    accountStatementsSettings.value = await getSetting(
      "accountStatements",
      SettingsCategory.CL_ACCOUNT_STATEMENTS
    );

    periodDates.value = {
      startDate: route.query.startDate as string,
      endDate: route.query?.endDate as string || null,
      startTimestamp: route.query?.startTimestamp as string,
      endTimestamp: route.query?.endTimestamp as string || null,
    } as IStatementsPeriod;

    statementDetails.value = await fetchStatementDetails();
    statementTransactions.value = statementDetails.value.transactions;

    if (statementDetails.value.currency) {
      await store.dispatch(
        "creditLine/setCurrency",
        statementDetails.value.currency
      );
    }

    if (isAndroid() && typeof Android?.downloadStatement !== "function") {
      hideDownloadBtn.value = true;
    }

    loading.value = false;
  } catch (error) {
    const typedError = error as Record<string, unknown> | undefined;
    DatadogLogger.Log(
      `Credit Line Error: ${JSON.stringify(error)}`,
      typedError,
      LogType.ERROR
    );
  }
});

const goBack = () => router.back();

const dismissAlert = () => (showAlert.value = false);

const getTransactionCopy = (transaction: IAccountTransaction): string => {
  return `${getTransactionSource(transaction.source, t, te)} - ${getTransactionType(
    transaction.type,
    t,
    te
  )}`;
};

const downloadStatement = () => {
  if (route.query?.isDelinquent === "true") {
    showAlert.value = true;
  } else {
    try {
      const fileDateTitle =
        periodDates.value?.endDate ||
        new Date()
          .toLocaleDateString(getLanguageName(), {
            day: "2-digit",
            month: "short",
            year: "2-digit",
          })
          .toLowerCase();
      const element = document.getElementById("statement-detail");
      const pdf = html2pdf().from(element);

      if (isAndroid()) {
        pdf.outputPdf().then(function (pdf) {
          Android.downloadStatement(btoa(pdf), fileDateTitle);
        });
      } else {
        pdf.save(fileDateTitle);
      }
    } catch (error) {
      const typedError = error as Record<string, unknown> | undefined;
      DatadogLogger.Log(
        `Credit Line Error: ${JSON.stringify(error)}`,
        typedError,
        LogType.ERROR
      );
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  float: left;
}
h1 {
  font-size: large;
  float: right;
  margin-top: 0.75rem;
  margin-bottom: 0;
}

.info ul {
  list-style-type: none;
  padding: 0;
}

.date-payment {
  grid-template-columns: 50% 50%;
  grid-gap: 0;
  border: 1px solid black;
  padding: 0.3em;
  background-color: lightgray;
  margin: 0;
}

.account-summary tbody th {
  font-weight: normal;
  text-align: start;
  padding-left: 0;
}

.account-summary tbody td {
  padding-right: 0;
}

.account-summary tbody tr {
  padding-top: 0;
  padding-left: 0;
}

.costs-table {
  width: 100%;
  table-layout: auto;
}

.costs-table .commissions-label {
  width: 24%;
  max-width: 140px;
  vertical-align: top;
  padding-right: 0.5rem;
}

.costs-table .commissions-value {
  width: 100%;
  overflow: visible;
  word-break: keep-all;
  -webkit-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

.credit-info {
  grid-template-columns: 50% 50%;
  margin: 0;
  font-size: medium;
}

#ops-detail-title {
  font-size: medium;
  margin-bottom: 0.5rem !important;
}

.info-title {
  font-size: medium;
}

tbody th {
  font-weight: normal;
  text-align: start;
  padding-left: 0;
}

tbody td {
  font-weight: normal;
  text-align: start;
  padding-right: 0;
}

.contact-info thead th {
  border-bottom: 2px solid black !important;
}

.disputes-table thead th {
  border-bottom: 2px solid black !important;
}

#download-btn {
  font-size: large;
  font-weight: bold;
}

.contact-info table {
  width: 100%;
  table-layout: auto;
}

.contact-info .contact-label {
  width: 24%;
  max-width: 140px;
  vertical-align: top;
  white-space: nowrap;
  padding-right: 0.5rem;
}

.contact-info .contact-value {
  width: 76%;
  white-space: nowrap;
  overflow: visible;
  word-break: normal;
  -webkit-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

.contact-info tbody th[colspan="4"] {
  width: 100%;
  text-align: left;
  padding-right: 0;
}
</style>
